import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["type", "disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BButton',
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    icon: {},
    type: { default: "button" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", `btn-${props.size} btn-${props.variant}`]),
    type: _ctx.type,
    disabled: _ctx.disabled || _ctx.loading
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["bi pe-1", _ctx.icon]),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})